module.exports = "/_next/static/images/15995c91cd22b83dda3f1b63920dcd3c-Nubank_HickDuarte_59058 1_lg.png.webp";